import { render, staticRenderFns } from "./subject_sideonset.vue?vue&type=template&id=a598790a&scoped=true"
import script from "./subject_sideonset.vue?vue&type=script&lang=js"
export * from "./subject_sideonset.vue?vue&type=script&lang=js"
import style0 from "./subject_sideonset.vue?vue&type=style&index=0&id=a598790a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a598790a",
  null
  
)

export default component.exports